import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import { getConfig } from 'src/configs'

const config = getConfig()
export const useSsrStore = defineStore('ssr', () => {
  const gamesByManufacturer = ref(null)
  const gameObject = ref(null)
  const gameObjectLoaded = ref(false)

  const gameObjectData = computed(() => {
    return gameObject.value?.game ?? null
  })
  const getGameObjectData = computed(() => {
    return gameObject.value?.game ?? null
  })
  const showSport = computed(() => {
    return Boolean(config.sportsBookLink)
  })

  function updateGameObject(payload) {
    if (payload) {
      gameObject.value = { ...payload, game: { ...payload.game } }
    } else {
      gameObject.value = null
    }
  }

  function updateGameObjectLoaded(payload) {
    gameObjectLoaded.value = payload
  }

  return {
    // refs
    gamesByManufacturer,
    gameObject,
    gameObjectLoaded,
    // computed
    gameObjectData,
    getGameObjectData,
    showSport,
    //functions
    updateGameObject,
    updateGameObjectLoaded,
  }
})
